import AuthLayout from "layouts/authLayout/AuthLayout";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Footer, Header } from "stories";
import { FooterChildren, HeaderChildren } from "../auth_views";
import { SignInCard } from "./signInCard/SignInCard";

const SignIn = () => {
  return (
    <AuthLayout headerSpacing>
      <Helmet>
        <title>Sign in | Fundever</title>
      </Helmet>
      <Header>
        <HeaderChildren linkedTo={"/sign-up"} />
      </Header>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <SignInCard />
          </Col>
        </Row>
      </Container>
      <Footer>
        <FooterChildren />
      </Footer>
    </AuthLayout>
  );
};

export default SignIn;
